module.exports = __webpack_public_path__ + "static/media/73.b3cf2dbb.jpg";